import {
    faBookOpen,
    faEnvelopeOpenText, faEuroSign,
    faFileAlt,
    faListAlt,
    faMapPin, faNewspaper,
    faQuestionCircle
} from "@fortawesome/free-solid-svg-icons";

interface SearchItem {
    label: string;
    category: string;
    link: string;
    color: string;
    icon: any;
}

export const searchItems: SearchItem[] = [
    {
        label: "Publications",
        category: "Ressources",
        link: "/les-publications",
        color: "#1976d2",
        icon: faBookOpen
    },
    {
        label: "Don pour la campagne",
        category: "Donation",
        link: "/vld-2026/faire-un-don",
        color: "#1976d2",
        icon: faEuroSign
    },
    {
        label: "Carte Interactive",
        category: "Expérience",
        link: "/carte-interactive",
        color: "#1976d2",
        icon: faMapPin
    },
    {
        label: "Enquêtes",
        category: "Ressources",
        link: "/les-enquetes",
        color: "#43a047",
        icon: faListAlt
    },
    {
        label: "F.A.Q",
        category: "Support",
        link: "/faq",
        color: "#ffb300",
        icon: faQuestionCircle
    },
    {
        label: "Contactez-nous",
        category: "Support",
        link: "/contactez-nous",
        color: "#d32f2f",
        icon: faEnvelopeOpenText
    },
];

export const news = [
    {
        id: "2025-10-31",
        title: " PLUi voté : quels impacts concernant votre propriété ?",
        date: "31 Octobre 2025",
        description: "La CAPF a publié le PLUi adopté le 16 octobre dernier. Dans la philosophie de VLD, nous souhaitons apporter une information fiable et objective afin d'enrichir le débat public.",
        url: "/article/2025-10-31"
    },
    {
        id: "2025-10-09",
        title: "Eau de Bois-le-Roi : exigeons la transparence",
        date: "9 Octobre 2025",
        description: "Depuis 2023, la présence de perchlorates dans l'eau est surveillée. Un enjeu de santé publique qui mérite toute notre attention.",
        url: "/article/2025-10-09"
    },
    {
        id: "2025-09-09",
        title: "Donnons aux associations sportives bacottes l’espace et l’énergie qu’elles méritent !",
        date: "9 Septembre 2025",
        description: "Retour sur le Forum des Associations : les attentes des bénévoles, les projets de gymnase temporaire et d’ombrière solaire, et l’engagement de VLD2026 pour la vie associative locale.",
        url: "/article/2025-09-09"
    },
    {
        id: "2025-08-27",
        title: "Le PLUi de la CAPF est-il attaquable ? Strasbourg nous montre la voie !",
        date: "27 Juillet 2025",
        description:
            "Avec #VLD2026, nous défendons une urbanisation maîtrisée, respectueuse de l’environnement et des habitants.",
        url: "/article/2025-08-27"
    },
    {
        id: "2025-06-21",
        title: "Synthèse de la commission d'enquête publique du PLUi ",
        date: "21 Juin 2025",
        description:
            "De nombreuses observations ont été émises pour exprimer une vive opposition aux secteurs de mixité sociale prévus dans la commune de Bois-le-Roi.",
        url: "/article/2025-06-21"
    },
    {
        id: "2025-04-11",
        title: "Contribution de l’association à l’enquête publique sur le PLUi",
        date: "11 Avril 2025",
        description:
            "L’association Vivre la démocratie à BLR dénonce une concertation insuffisante sur le PLUi et s’oppose à la mise en place des Secteurs de Mixité Sociale, jugée injuste pour les habitants et propriétaires.",
        url: "/article/2025-04-11"
    }
];

export const tracts = [
    {
        id: "2025-04-11",
        title: "Tract 42 - Fin du projet sportif",
        date: "11 Avril 2025",
        description:
            "Retour sur le conseil municipal du 10 avril 2025 : toutes les infos sur la fin du projet sportif, décisions et enjeux expliqués simplement.",
        url: "/publication/2025-04-11"
    },
    {
        id: "2025-04-04",
        title: "Tract 41 - L'association VLD",
        date: "4 Avril 2025",
        description:
            "Présentation de l'association VLD : ses missions, ses actions récentes et son rôle lors du conseil municipal. Focus sur les initiatives portées par VLD et leur impact local.",
        url: "/publication/2025-04-04"
    },
    {
        id: "2024-08-24",
        title: "Tract 40 - Remarques sur le PLUi",
        date: "24 Août 2024",
        description:
            "Analyse critique du projet de PLUi à Bois-le-Roi : absence de concertation, décisions sur la mixité sociale, conséquences pour les propriétaires et demandes d’ajustements pour préserver la commune.",
        url: "/publication/2024-08-24"
    },
    {
        id: "2024-06-26",
        title: "Tract 38 – Bilan PLUi & réunions publiques",
        date: "26 juin 2024",
        description: "Synthèse des 4 réunions PLUi, dénonciation du manque de concertation et appel à la médiation pour la commune.",
        url: "/publication/2024-06-26"
    },
    {
        id: "2024-06-25",
        title: "Tract 37 - PLUi Bois-le-Roi : épisode 3",
        date: "25 juin 2024",
        description: "Réunion houleuse sur le PLUi, montée des tensions, demande de retrait du projet par l’association Vivre la Démocratie à BLR.",
        url: "/publication/2024-06-25"
    },
    {
        id: "2024-06-18",
        title: "Tract 36 - Alerte rouge sur le PLUi de Bois-le-Roi",
        date: "18 juin 2024",
        description: "Synthèse et dates-clés des projets imposant de fortes proportions de logements sociaux. Explications sur les nouveaux secteurs dits 'de mixité sociale' et invitation aux réunions.",
        url: "/publication/2024-06-18"
    },
    {
        id: "2024-06-06",
        title: "Tract 35 - PLUi: réunions en juin à Bois-le-Roi",
        date: "06 Juin 2024",
        description: "Appel à la mobilisation des habitants pour débattre du futur cadre de vie dans le cadre du PLUi. Quatre réunions publiques sont organisées en juin.",
        url: "/publication/2024-06-06"
    },
    {
        id: "2024-04-15",
        title: "Tract 34 - Chronique financière 2018-2024",
        date: "15 avril 2024",
        description: "Bilan détaillé des finances et de la gouvernance communale de 2018 à 2024, accompagné de graphiques d’évolution.",
        url: "/publication/2024-04-15"
    },
    {
        id: "2024-03-20",
        title: "Tract 33 - Abandon du projet de crèche",
        date: "20 mars 2024",
        description: "Retour sur l'abandon du projet de crèche, analyse des causes financières et proposition pour l'avenir du Bois de la source.",
        url: "/publication/2024-03-20"
    },
    {
        id: "2024-01-17",
        title: "Tract 32 - « Tout va très bien Madame la Marquise ! »",
        date: "17 janvier 2024",
        description: "Lettre d'informations 32 : retour sur la dégradation rapide des finances communales, imposant une accélération des obligations SRU et l’éventualité de mesures préfectorales.",
        url: "/publication/2024-01-17"
    },
    {
        id: "2023-12-19",
        title: "Tract 31 - Sauvons le Bois de la source !",
        date: "19 décembre 2023",
        description: "Alternatives à la destruction du Bois de la source pour la construction d'une crèche municipale : enjeux environnementaux, urbanistiques et propositions concrètes.",
        url: "/publication/2023-12-19"
    },
    {
        id: "2023-12-03",
        title: "Tract 29 - Convention avec la SAFER (2)",
        date: "3 décembre 2023",
        description: "Analyse et propositions sur la convention SAFER, enjeux de préemption et protection des espaces naturels. Appel à la vigilance et au refus de la convention en l’état.",
        url: "/publication/2023-12-03"
    },
    {
        id: "2023-11-08",
        title: "Tract 28 - Convention SAFER : alerte vigilance",
        date: "08 novembre 2023",
        description: "Pourquoi nous alertons sur la convention proposée avec la SAFER et ses risques pour la commune. Appel à la vigilance collective.",
        url: "/publication/2023-11-08"
    },
    {
        id: "2023-11-03",
        title: "Tract 27 - Alerte sur nos finances",
        date: "03 novembre 2023",
        description: "Analyse critique de la situation financière de Bois-le-Roi, alertes sur les risques de faillite et demande d’un plan de redressement en urgence.",
        url: "/publication/2023-11-03"
    },
    {
        id: "2023-09-16",
        title: "Tract 26 - Projet d’équipements sportifs : flou et inquiétudes",
        date: "16 septembre 2023",
        description: "Analyse du projet d'équipements sportifs : manque de plan de financement, de concertation, et d'engagements clairs de la municipalité.",
        url: "/publication/2023-09-16"
    },
    {
        id: "2023-09-15",
        title: "Tract 25 - L'enjeu écologique",
        date: "15 septembre 2023",
        description: "Focus sur le contexte climatique et les grandes décisions municipales impactant l’écologie et la qualité de vie à Bois-le-Roi.",
        url: "/publication/2023-09-15"
    },
    {
        id: "2023-07-06",
        title: "Tract 24 - Création de l'association « Vivre la démocratie à BLR »",
        date: "06 juillet 2023",
        description: "Annonce et valeurs fondatrices de la nouvelle association citoyenne « Vivre la démocratie à BLR » pour la défense de la qualité de vie, l’environnement et la démocratie locale à Bois-le-Roi.",
        url: "/publication/2023-07-06"
    },
    // Ajoutez ici d'autres tracts si besoin
];

export const tracts2026 = [
    {
        id: "2026-03-16",
        title: "Résultats du 1er tour : VLD en tête, mobilisation générale pour le 2nd tour",
        date: "16 mars 2026",
        description:
            "Merci pour votre confiance. Découvrez les résultats, la vidéo de Jean-Philippe Guibert et l’appel à la mobilisation pour le 2nd tour du 22 mars.",
        url: "/vld-2026/publication/2026-03-16",
    },
    {
        id: "2026-03-06",
        title: "Circulaire de profession de foi",
        date: "6 mars 2026",
        description: "Jean-Phillipe GUIBERT et son équipe présentent leur profession de foi pour les élections municipales.",
        url: "/vld-2026/publication/2026-03-06",
    },
    {
        id: "2026-02-22",
        title: "Complément d’information n°3 sur le tract n°3 dédié aux finances",
        date: "22 février 2026",
        description: "Information complémentaire sur l’évolution des charges de fonctionnement à Bois-le-Roi.",
        url: "/vld-2026/publication/2026-02-22",
    },
    {
        id: "2026-02-14",
        title: "Complément d’information n°2 sur le tract n°3 dédié aux finances",
        date: "14 février 2026",
        description: "Information complémentaire dédiée aux impôts locaux à Bois-le-Roi.",
        url: "/vld-2026/publication/2026-02-14",
    },
    {
        id: "2026-01-14",
        title: "Tract 4 – VLD 2026 : Jean-Philippe Guibert",
        date: "14 janvier 2026",
        description:
            "Présentation du candidat, engagements et démocratie participative : transparence, écoute et règles claires au cœur du projet.",
        url: "/vld-2026/publication/2026-01-14",
    },
    {
        id: "2025-12-30",
        title: "Tract 3 (Complément) – VLD 2026 : Complément d'information sur le tract n°3 dédié aux finances",
        date: "30 décembre 2025",
        description: "Nous souhaitons apporter une information complémentaire pour enrichir le débat public.",
        url: "/vld-2026/publication/2025-12-30",
    },
    {
        id: "2025-11-21",
        title: "Tract 3 – VLD 2026 : redonner à notre commune une gestion saine et responsable !",
        date: "11 novembre 2025",
        description: "Chez VLD nous souhaitons apporter une information fiable et objective pour enrichir le débat public.",
        url: "/vld-2026/publication/2025-11-21",
    },
    {
        id: "2025-10-09",
        title: "Tract 2 – VLD 2026 : à la rencontre de notre tête de liste, Jean-Philippe Guibert",
        date: "9 octobre 2025",
        description: "Jean-Philippe Guibert, tête de liste de VLD 2026 – présentation de sa candidature.",
        url: "/vld-2026/publication/2025-10-09",
    },
    {
        id: "2025-06-15",
        title: "Tract 1 – VLD2026 : Sursaut pour Bois-le-Roi",
        date: "15 juin 2025",
        description: "Annonce de candidature VLD2026, diagnostic communal et engagements clés pour Bois-le-Roi.",
        url: "/vld-2026/publication/2025-06-15",
    },
];

// Transforme tracts et news pour matcher la structure attendue
const tractSearchItems = tracts.map(t => ({
    label: t.title,
    category: "Tract",
    link: t.url,
    color: "#1565c0",
    icon: faFileAlt
}));

const tract2026SearchItems = tracts2026.map(t => ({
    label: t.title,
    category: "Tract",
    link: t.url,
    color: "#1565c0",
    icon: faFileAlt
}));

const newsSearchItems = news.map(n => ({
    label: n.title,
    category: "Actualité",
    link: n.url,
    color: "#ff9800",
    icon: faNewspaper
}));

// Regroupe tout dans ton tableau principal
export const allSearchItems = [
    ...searchItems,
    ...tractSearchItems,
    ...newsSearchItems,
    ...tract2026SearchItems
];
